// pages/bank/BankAccountList.jsx
import React, { useState, useEffect, useCallback, useMemo } from 'react';
//import { useNavigate } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setToogleHeader } from '../../core/redux/action';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
//import dayjs from 'dayjs';
import Select from 'react-select';
//import { DatePicker } from 'antd';
import Table from '../../core/pagination/datatable';
import { 
    ChevronUp, 
    RotateCcw, 
    Sliders, 
    Filter,
    Search,
    Eye,
    Edit,
    Trash2,
    PlusCircle,
    Download,
    Printer,
    DollarSign,
    TrendingUp,
    TrendingDown,
    RefreshCw,
    Star,
    CreditCard,
    //Landmark,
    //Wallet,
    Repeat,
    Briefcase,
    Home,
    Circle
} from 'feather-icons-react/build/IconComponents';
import { bankActions } from '../../core/action/bankActions';
import AddBankAccount from '../../core/modals/bank/AddBankAccount';
import EditBankAccount from '../../core/modals/bank/EditBankAccount';
import ViewBankAccount from '../../core/modals/bank/ViewBankAccount';
import TransactionModal from '../../core/modals/bank/TransactionModal';
import TransferModal from '../../core/modals/bank/TransferModal';

//const { RangePicker } = DatePicker;
const MySwal = withReactContent(Swal);

const BankAccountList = () => {
    //const navigate = useNavigate();
    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);
    
    // State
    const [accounts, setAccounts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [summaryLoading, setSummaryLoading] = useState(false);
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [summary, setSummary] = useState({
        total_balance: 0,
        account_count: 0,
        total_credit: 0,
        total_debit: 0
    });
    
    // Modal states
    const [modalType, setModalType] = useState(null);
    const [selectedAccount, setSelectedAccount] = useState(null);
    
    // Pagination
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 1
    });
    
    // Filters
    const [filters, setFilters] = useState({
        search: '',
        account_type: '',
        status: 'active',
        bank_name: ''
    });
    
    // Sort options
    const sortOptions = useMemo(() => [
        { value: 'account_name', label: 'Account Name' },
        { value: 'bank_name', label: 'Bank Name' },
        { value: 'balance_high', label: 'Highest Balance' },
        { value: 'balance_low', label: 'Lowest Balance' },
        { value: 'newest', label: 'Newest First' },
        { value: 'oldest', label: 'Oldest First' }
    ], []);
    
    const [sortOption, setSortOption] = useState('account_name');
    
    // Account type options
    const accountTypeOptions = useMemo(() => [
        { value: '', label: 'All Types' },
        { value: 'savings', label: 'Savings Account' },
        { value: 'current', label: 'Current Account' },
        { value: 'cash', label: 'Cash Account' },
        { value: 'credit_card', label: 'Credit Card' },
        { value: 'loan', label: 'Loan Account' }
    ], []);
    
    // Status options
    const statusOptions = useMemo(() => [
        { value: '', label: 'All Status' },
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' }
    ], []);

    // Load initial data
    useEffect(() => {
        loadAccounts();
        loadSummary();
    }, []); // Only run once on mount

    // Load accounts - Memoized to prevent unnecessary recreations
    const loadAccounts = useCallback(async (page = pagination.page) => {
        try {
            setLoading(true);
            
            const params = {
                page,
                limit: pagination.limit,
                search: filters.search || undefined,
                account_type: filters.account_type || undefined,
                status: filters.status || undefined,
                bank_name: filters.bank_name || undefined,
                sort: sortOption
            };
            
            const result = await bankActions.getAccounts(params);
            
            if (result.success) {
                setAccounts(result.data || []);
                setPagination({
                    page: result.page || page,
                    limit: pagination.limit,
                    total: result.total || 0,
                    totalPages: result.totalPages || 1
                });
            } else {
                MySwal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: result.message || 'Failed to load bank accounts',
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        } catch (error) {
            console.error('Error loading accounts:', error);
        } finally {
            setLoading(false);
        }
    }, [pagination.limit, filters.search, filters.account_type, filters.status, filters.bank_name, sortOption]);

// Load summary - FIXED for your PHP structure
const loadSummary = useCallback(async () => {
    // Prevent multiple simultaneous calls
    if (summaryLoading) return;
    
    try {
        setSummaryLoading(true);
        
        // Get account summary from API
        const summaryResult = await bankActions.getSummary();
        
        console.log('Summary API Response:', summaryResult); // Debug log
        
        // Initialize summary with default values
        let updatedSummary = {
            total_balance: 0,
            account_count: 0,
            total_credit: 0,
            total_debit: 0
        };
        
        // Extract data from the response
        if (summaryResult.success && summaryResult.data) {
            // Get account summary from the overall data
            if (summaryResult.data.overall) {
                updatedSummary = {
                    total_balance: parseFloat(summaryResult.data.overall.total_balance) || 0,
                    account_count: parseInt(summaryResult.data.overall.active_accounts) || 
                                  parseInt(summaryResult.data.overall.total_accounts) || 0,
                    total_credit: 0, // Will be filled from monthly data
                    total_debit: 0    // Will be filled from monthly data
                };
            } 
            // Fallback to summary object if available
            else if (summaryResult.data.summary) {
                updatedSummary = {
                    total_balance: parseFloat(summaryResult.data.summary.total_balance) || 0,
                    account_count: parseInt(summaryResult.data.summary.account_count) || 0,
                    total_credit: 0,
                    total_debit: 0
                };
            }
            
            // Get monthly transaction data from the monthly object
            if (summaryResult.data.monthly) {
                updatedSummary.total_credit = parseFloat(summaryResult.data.monthly.total_credits) || 0;
                updatedSummary.total_debit = parseFloat(summaryResult.data.monthly.total_debits) || 0;
            }
            
            // If monthly data isn't available in the summary, fetch it separately
            if (!summaryResult.data.monthly && updatedSummary.total_credit === 0) {
                try {
                    // Get current month's date range
                    const now = new Date();
                    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                    
                    const fromDate = startOfMonth.toISOString().split('T')[0];
                    const toDate = endOfMonth.toISOString().split('T')[0];
                    
                    const transSummary = await bankActions.getTransactionSummary({
                        from_date: fromDate,
                        to_date: toDate
                    });
                    
                    if (transSummary.success && transSummary.data) {
                        updatedSummary.total_credit = parseFloat(transSummary.data.total_credit) || 0;
                        updatedSummary.total_debit = parseFloat(transSummary.data.total_debit) || 0;
                    }
                } catch (transError) {
                    console.error('Error fetching transaction summary:', transError);
                }
            }
        }
        
        console.log('Final Updated Summary:', updatedSummary); // Debug log
        setSummary(updatedSummary);
        
    } catch (error) {
        console.error('Error in loadSummary:', error);
    } finally {
        setSummaryLoading(false);
    }
}, [summaryLoading]);

   // Update summary when accounts change
useEffect(() => {
    if (accounts.length > 0 && !summaryLoading) {
        loadSummary();
    }
}, [accounts]); // Use accounts, not accounts.length

    // Handle search with debounce
    const handleSearch = useCallback(() => {
        setPagination(prev => ({ ...prev, page: 1 }));
        loadAccounts(1);
    }, [loadAccounts]);

    // Debounced search input
    const handleSearchInput = useCallback((e) => {
        setFilters(prev => ({ ...prev, search: e.target.value }));
    }, []);

    const handleSearchKeyPress = useCallback((e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    }, [handleSearch]);

    // Toggle filter visibility
    const toggleFilterVisibility = useCallback(() => {
        setIsFilterVisible((prev) => !prev);
    }, []);

    // Reset filters
    const resetFilters = useCallback(() => {
        setFilters({
            search: '',
            account_type: '',
            status: 'active',
            bank_name: ''
        });
        setSortOption('account_name');
        setPagination(prev => ({ ...prev, page: 1 }));
        setTimeout(() => loadAccounts(1), 0);
    }, [loadAccounts]);

    // Handle filter change
    const handleFilterChange = useCallback((filterName, value) => {
        setFilters(prev => ({ ...prev, [filterName]: value }));
    }, []);

    // Handle sort change
    const handleSortChange = useCallback((option) => {
        setSortOption(option?.value || 'account_name');
        setPagination(prev => ({ ...prev, page: 1 }));
        setTimeout(() => loadAccounts(1), 0);
    }, [loadAccounts]);

    // Handle page change
    const handlePageChange = useCallback((page) => {
        setPagination(prev => ({ ...prev, page }));
        loadAccounts(page);
    }, [loadAccounts]);

    // Modal handlers
    const handleAdd = useCallback(() => {
        setModalType('add');
        setSelectedAccount(null);
    }, []);

    const handleView = useCallback((account) => {
        setSelectedAccount(account);
        setModalType('view');
    }, []);

    const handleEdit = useCallback((account) => {
        setSelectedAccount(account);
        setModalType('edit');
    }, []);

    const handleTransaction = useCallback((account) => {
        setSelectedAccount(account);
        setModalType('transaction');
    }, []);

    const handleTransfer = useCallback(() => {
        setModalType('transfer');
    }, []);

    const handleModalClose = useCallback(() => {
        setModalType(null);
        setSelectedAccount(null);
    }, []);

    const handleSuccess = useCallback(() => {
        loadAccounts(pagination.page);
        loadSummary();
        handleModalClose();
    }, [loadAccounts, loadSummary, handleModalClose, pagination.page]);

    // Handle delete
    const handleDelete = useCallback(async (account) => {
        // Check if balance is zero
        if (parseFloat(account.current_balance) !== 0) {
            MySwal.fire({
                icon: 'warning',
                title: 'Cannot Delete',
                text: 'Only accounts with zero balance can be deleted.',
                timer: 2000,
                showConfirmButton: false
            });
            return;
        }

        const result = await MySwal.fire({
            title: 'Delete Bank Account?',
            html: `
                <div class="text-start">
                    <p>Are you sure you want to delete this bank account?</p>
                    <p><strong>Account:</strong> ${account.account_name}</p>
                    <p><strong>Bank:</strong> ${account.bank_name}</p>
                    <p><strong>Balance:</strong> ${formatCurrency(account.current_balance || 0)}</p>
                    <p class="text-danger">This action cannot be undone.</p>
                </div>
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {
                setLoading(true);
                const deleteResult = await bankActions.deleteAccount(account.id);
                
                if (deleteResult.success) {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Bank account has been deleted.',
                        timer: 1500,
                        showConfirmButton: false
                    });
                    loadAccounts(pagination.page);
                    loadSummary();
                } else {
                    MySwal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: deleteResult.message || 'Failed to delete account',
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
            } catch (error) {
                console.error('Error deleting account:', error);
            } finally {
                setLoading(false);
            }
        }
    }, [loadAccounts, loadSummary, pagination.page]);

    // Handle set default
    const handleSetDefault = useCallback(async (id) => {
        try {
            const result = await bankActions.setDefaultAccount(id);
            if (result.success) {
                loadAccounts(pagination.page);
                MySwal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Default account updated',
                    timer: 1500,
                    showConfirmButton: false
                });
            }
        } catch (error) {
            console.error('Error setting default:', error);
        }
    }, [loadAccounts, pagination.page]);

    // Refresh handler
    const handleRefresh = useCallback(() => {
        loadAccounts();
        loadSummary();
    }, [loadAccounts, loadSummary]);

    // Get account icon based on type
    const getAccountIcon = useCallback((type) => {
        switch(type?.toLowerCase()) {
            case 'savings':
                return <Briefcase size={20} className="text-primary" />;
            case 'current':
                return <Home size={20} className="text-success" />;
            case 'cash':
                return <DollarSign size={20} className="text-info" />;
            case 'credit_card':
                return <CreditCard size={20} className="text-warning" />;
            default:
                return <Circle size={20} className="text-secondary" />;
        }
    }, []);

    // Format account number (mask)
    const formatAccountNumber = useCallback((accNo) => {
        if (!accNo) return 'N/A';
        const accStr = String(accNo);
        if (accStr.length <= 4) return accStr;
        const last4 = accStr.slice(-4);
        return `XXXXXX${last4}`;
    }, []);

    // Format currency helper
    const formatCurrency = useCallback((amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount || 0);
    }, []);

    // Format account type helper
    const formatAccountType = useCallback((type) => {
        const types = {
            'savings': 'Savings Account',
            'current': 'Current Account',
            'cash': 'Cash Account',
            'credit_card': 'Credit Card',
            'loan': 'Loan Account'
        };
        return types[type?.toLowerCase()] || type || 'N/A';
    }, []);

    // Table columns - Memoized to prevent unnecessary re-renders
    const columns = useMemo(() => [
        {
            title: "Account",
            dataIndex: "account_name",
            sorter: true,
            render: (text, record) => (
                <div className="d-flex align-items-center">
                    <div className="avatar avatar-md bg-light rounded d-flex align-items-center justify-content-center me-3">
                        {getAccountIcon(record.account_type)}
                    </div>
                    <div>
                        <div className="d-flex align-items-center flex-wrap">
                            <strong className="me-2">{text || 'Unnamed Account'}</strong>
                            {record.is_default === 1 && (
                                <span className="badge bg-primary" title="Default Account">
                                    <Star size={12} className="me-1" />
                                    Default
                                </span>
                            )}
                        </div>
                        <div className="text-muted small">
                            {record.bank_name || 'No Bank'} | {formatAccountNumber(record.account_number)}
                        </div>
                    </div>
                </div>
            ),
        },
        {
            title: "Account Type",
            dataIndex: "account_type",
            render: (text) => (
                <span className="badge bg-light text-dark p-2">
                    {formatAccountType(text)}
                </span>
            ),
        },
        {
            title: "Current Balance",
            dataIndex: "current_balance",
            sorter: true,
            render: (text, record) => (
                <div>
                    <strong className={parseFloat(text) >= 0 ? 'text-success' : 'text-danger'}>
                        {formatCurrency(text)}
                    </strong>
                    <br />
                    <small className="text-muted">
                        Opening: {formatCurrency(record.opening_balance)}
                    </small>
                </div>
            ),
        },
        {
            title: "Branch/IFSC",
            render: (text, record) => (
                <div>
                    <div>{record.branch_name || 'N/A'}</div>
                    <small className="text-muted">IFSC: {record.ifsc_code || 'N/A'}</small>
                </div>
            ),
        },
        {
            title: "Contact",
            render: (text, record) => (
                <div>
                    <div>{record.contact_person || 'N/A'}</div>
                    <small className="text-muted">{record.contact_phone || ''}</small>
                </div>
            ),
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text) => (
                <span className={text?.toLowerCase() === 'active' ? 'badge bg-success' : 'badge bg-danger'}>
                    {text?.toUpperCase() || 'INACTIVE'}
                </span>
            ),
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (text, record) => (
                <div className="btn-group btn-group-sm" role="group">
                    <OverlayTrigger placement="top" overlay={<Tooltip>View Details</Tooltip>}>
                        <button
                            className="btn btn-outline-info"
                            onClick={() => handleView(record)}
                        >
                            <Eye size={14} />
                        </button>
                    </OverlayTrigger>
                    
                    <OverlayTrigger placement="top" overlay={<Tooltip>Edit Account</Tooltip>}>
                        <button
                            className="btn btn-outline-primary"
                            onClick={() => handleEdit(record)}
                        >
                            <Edit size={14} />
                        </button>
                    </OverlayTrigger>
                    
                    <OverlayTrigger placement="top" overlay={<Tooltip>Add Transaction</Tooltip>}>
                        <button
                            className="btn btn-outline-success"
                            onClick={() => handleTransaction(record)}
                        >
                            <DollarSign size={14} />
                        </button>
                    </OverlayTrigger>
                    
                    {record.is_default !== 1 && (
                        <OverlayTrigger placement="top" overlay={<Tooltip>Set as Default</Tooltip>}>
                            <button
                                className="btn btn-outline-warning"
                                onClick={() => handleSetDefault(record.id)}
                            >
                                <Star size={14} />
                            </button>
                        </OverlayTrigger>
                    )}
                    
                    <OverlayTrigger placement="top" overlay={<Tooltip>Delete Account</Tooltip>}>
                        <button
                            className="btn btn-outline-danger"
                            onClick={() => handleDelete(record)}
                            disabled={parseFloat(record.current_balance) !== 0}
                        >
                            <Trash2 size={14} />
                        </button>
                    </OverlayTrigger>
                </div>
            ),
        },
    ], [getAccountIcon, formatAccountNumber, formatCurrency, formatAccountType, handleView, handleEdit, handleTransaction, handleSetDefault, handleDelete]);

    // Tooltip renderer
    const renderTooltip = useCallback((props, text) => (
        <Tooltip id={`tooltip-${text}`} {...props}>{text}</Tooltip>
    ), []);

    return (
        <div className="page-wrapper">
            <div className="content">
                {/* Header */}
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4>Bank Accounts</h4>
                            <h6>Manage your bank accounts and transactions</h6>
                        </div>
                    </div>
                    
                    <ul className="table-top-head">
                        <li>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleAdd}
                                disabled={loading}
                            >
                                <PlusCircle size={18} className="me-2" />
                                New Account
                            </button>
                        </li>
                        <li>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleTransfer}
                                disabled={accounts.length < 2}
                                title={accounts.length < 2 ? "Need at least 2 accounts for transfer" : ""}
                            >
                                <Repeat size={18} className="me-2" />
                                Transfer
                            </button>
                        </li>
                        <li>
                            <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Export')}>
                                <button className="btn btn-outline-primary">
                                    <Download size={18} />
                                </button>
                            </OverlayTrigger>
                        </li>
                        <li>
                            <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Print')}>
                                <button className="btn btn-outline-secondary" onClick={() => window.print()}>
                                    <Printer size={18} />
                                </button>
                            </OverlayTrigger>
                        </li>
                        <li>
                            <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Refresh')}>
                                <button 
                                    className="btn btn-outline-secondary" 
                                    onClick={handleRefresh}
                                    disabled={loading || summaryLoading}
                                >
                                    <RotateCcw size={18} />
                                </button>
                            </OverlayTrigger>
                        </li>
                        <li>
                            <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Collapse')}>
                                <button
                                    className={data ? "btn btn-outline-secondary active" : "btn btn-outline-secondary"}
                                    onClick={() => dispatch(setToogleHeader(!data))}
                                >
                                    <ChevronUp size={18} />
                                </button>
                            </OverlayTrigger>
                        </li>
                    </ul>
                </div>

                {/* Summary Cards */}
                <div className="row mb-4">
                    <div className="col-xl-3 col-sm-6 col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <p className="mb-1 text-muted">Total Balance</p>
                                        <h3 className="mb-0 text-primary">{formatCurrency(summary.total_balance)}</h3>
                                        <small className="text-muted">{summary.account_count} Accounts</small>
                                    </div>
                                    <div className="bg-primary bg-opacity-10 rounded-circle p-3">
                                        <DollarSign size={24} className="text-primary" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-sm-6 col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <p className="mb-1 text-muted">Total Credits</p>
                                        <h3 className="mb-0 text-success">{formatCurrency(summary.total_credit)}</h3>
                                        <small className="text-muted">This month</small>
                                    </div>
                                    <div className="bg-success bg-opacity-10 rounded-circle p-3">
                                        <TrendingUp size={24} className="text-success" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-sm-6 col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <p className="mb-1 text-muted">Total Debits</p>
                                        <h3 className="mb-0 text-danger">{formatCurrency(summary.total_debit)}</h3>
                                        <small className="text-muted">This month</small>
                                    </div>
                                    <div className="bg-danger bg-opacity-10 rounded-circle p-3">
                                        <TrendingDown size={24} className="text-danger" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-sm-6 col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <p className="mb-1 text-muted">Net Flow</p>
                                        <h3 className="mb-0 text-info">
                                            {formatCurrency(summary.total_credit - summary.total_debit)}
                                        </h3>
                                        <small className="text-muted">This month</small>
                                    </div>
                                    <div className="bg-info bg-opacity-10 rounded-circle p-3">
                                        <RefreshCw size={24} className="text-info" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Filters Card */}
                <div className="card table-list-card">
                    <div className="card-body">
                        <div className="table-top">
                            <div className="search-set">
                                <div className="search-input">
                                    <input
                                        type="text"
                                        placeholder="Search by account name, bank, number..."
                                        className="form-control form-control-sm formsearch"
                                        value={filters.search}
                                        onChange={handleSearchInput}
                                        onKeyPress={handleSearchKeyPress}
                                    />
                                    <button 
                                        className="btn btn-searchset" 
                                        onClick={handleSearch}
                                        disabled={loading}
                                    >
                                        <Search size={16} />
                                    </button>
                                </div>
                            </div>
                            
                            <div className="search-path">
                                <div className="d-flex align-items-center">
                                    <button 
                                        className={`btn btn-filter ${isFilterVisible ? "setclose" : ""}`} 
                                        onClick={toggleFilterVisibility}
                                    >
                                        <Filter size={18} />
                                    </button>
                                </div>
                            </div>
                            
                            <div className="form-sort">
                                <Sliders size={16} className="info-img me-2" />
                                <Select
                                    className="select"
                                    options={sortOptions}
                                    value={sortOptions.find(opt => opt.value === sortOption)}
                                    onChange={handleSortChange}
                                    placeholder="Sort by"
                                    isClearable={false}
                                />
                            </div>
                        </div>

                        {/* Filter Panel */}
                        <div
                            className={`card${isFilterVisible ? ' visible' : ''}`}
                            id="filter_inputs"
                            style={{ display: isFilterVisible ? 'block' : 'none' }}
                        >
                            <div className="card-body pb-0">
                                <div className="row">
                                    <div className="col-lg-3 col-sm-6 col-12">
                                        <div className="input-blocks">
                                            <label>Account Type</label>
                                            <Select
                                                options={accountTypeOptions}
                                                value={accountTypeOptions.find(t => t.value === filters.account_type)}
                                                onChange={(opt) => handleFilterChange('account_type', opt?.value || '')}
                                                placeholder="All Types"
                                                isClearable
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-6 col-12">
                                        <div className="input-blocks">
                                            <label>Status</label>
                                            <Select
                                                options={statusOptions}
                                                value={statusOptions.find(s => s.value === filters.status)}
                                                onChange={(opt) => handleFilterChange('status', opt?.value || '')}
                                                placeholder="All Status"
                                                isClearable
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-6 col-12">
                                        <div className="input-blocks">
                                            <label>Bank Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter bank name"
                                                value={filters.bank_name}
                                                onChange={(e) => handleFilterChange('bank_name', e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-6 col-12">
                                        <div className="input-blocks d-flex gap-2 mt-4">
                                            <button 
                                                className="btn btn-primary" 
                                                onClick={handleSearch}
                                                disabled={loading}
                                            >
                                                Apply Filters
                                            </button>
                                            <button 
                                                className="btn btn-secondary" 
                                                onClick={resetFilters}
                                                disabled={loading}
                                            >
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Accounts Table */}
                        <div className="table-responsive">
                            <Table 
                                columns={columns} 
                                dataSource={accounts} 
                                loading={loading}
                                pagination={{
                                    current: pagination.page,
                                    pageSize: pagination.limit,
                                    total: pagination.total,
                                    onChange: handlePageChange,
                                    showSizeChanger: true,
                                    showQuickJumper: true,
                                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} accounts`
                                }}
                                rowKey="id"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Modals */}
            {modalType === 'add' && (
                <AddBankAccount
                    onSuccess={handleSuccess}
                    onClose={handleModalClose}
                    isOpen={true}
                />
            )}

            {modalType === 'edit' && selectedAccount && (
                <EditBankAccount
                    accountId={selectedAccount.id}
                    onSuccess={handleSuccess}
                    onClose={handleModalClose}
                    isOpen={true}
                />
            )}

            {modalType === 'view' && selectedAccount && (
                <ViewBankAccount
                    account={selectedAccount}
                    onClose={handleModalClose}
                />
            )}

            {modalType === 'transaction' && selectedAccount && (
                <TransactionModal
                    account={selectedAccount}
                    onSuccess={handleSuccess}
                    onClose={handleModalClose}
                />
            )}

            {modalType === 'transfer' && (
                <TransferModal
                    accounts={accounts}
                    onSuccess={handleSuccess}
                    onClose={handleModalClose}
                />
            )}
        </div>
    );
};

export default BankAccountList;